<template>
  <div>
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />
    <div class="main-panel">
      <v-row>
        <v-col cols="12" md="7" class="pt-0">
          <div class="header text-left">Manage Pawn Interest Package IDs</div>
        </v-col>
        <v-col cols="12" md="5" class="action-buttons pt-0">
          <v-btn class="create-btn" color="#00457C" @click="addPawn"
            >Add Pawn Interest Package</v-btn
          >
        </v-col>
      </v-row>

      <!-- Table -->
      <TableComponent
        type="messages"
        v-bind:dynamicHeaders="dynamicHeaders"
        v-bind:dynamicWidths="dynamicWidths"
        v-bind:dynamicRowsDetail="dynamicRowsDetail"
        v-on:view-item="viewMsg"
        v-on:edit-item="editMsg"
        v-on:delete-item="openDeleteDialog"
        v-on:view-item-analytics="viewAnalytics"
      />
    </div>

    <div class="main-panel mt-5">
      <v-row>
        <v-col cols="12" md="7" class="pt-0">
          <div class="header text-left">Manage MGP Interest Package IDs</div>
        </v-col>
        <v-col cols="12" md="5" class="action-buttons pt-0">
          <v-btn class="create-btn" color="#00457C" @click="addMGP"
            >Add MGP Interest Package</v-btn
          >
        </v-col>
      </v-row>

      <!-- Table -->
      <TableComponent
        type="messages"
        v-bind:dynamicHeaders="dynamicHeaders1"
        v-bind:dynamicWidths="dynamicWidths"
        v-bind:dynamicRowsDetail="dynamicRowsDetail1"
        v-on:view-item="viewMsg"
        v-on:edit-item="editMsg"
        v-on:delete-item="openDeleteDialog"
        v-on:view-item-analytics="viewAnalytics"
      />
    </div>

    <v-dialog v-model="pawnDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Add Pawn Package IDs
        </v-card-title>

        <v-card-text class="mt-5">
          <v-autocomplete
            chips
            dense
            filled
            small-chips
            solo
            label="Select Package"
            v-model="selectedItem"
            :items="unselected_pawnids"
            item-text="PackageName"
            item-value="PackageId"
          >
          </v-autocomplete>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="submitPawn"> Add </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mgpDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Add MGP Package IDs
        </v-card-title>

        <v-card-text class="mt-5">
          <v-autocomplete
            chips
            dense
            filled
            small-chips
            solo
            label="Select Package"
            v-model="selectedItem"
            :items="unselected_mgpids"
            item-text="PackageName"
            item-value="PackageId"
          >
          </v-autocomplete>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="submitMGP"> Add </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import moment from "moment";
import Axios from "axios";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  data() {
    return {
      itemDeleteId: null,
      dialog: false,
      dynamicHeaders: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Actions", value: "actions" },
      ],
      dynamicHeaders1: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["130px", "90px", "90px"],
      dynamicRowsDetail: [],
      dynamicRowsDetail1: [],
      rawMsgDetails: [],
      currentMessageView: null,
      currentMessageAnalytics: null,
      loading: false,
      countUsers: 0,
      packages: [],
      pawn_ids: [],
      mgp_ids: [],
      pawnDialog: false,
      mgpDialog: false,
      unselected_pawnids: [],
      unselected_mgpids: [],
      selectedItem: "",
    };
  },
  created() {
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + "/api/interest/packageids"
    ).then((res) => {
      console.log("Successfully retrieved all packages");
      //   console.log(res.data);
      this.packages = res.data.data;

      Axios.get(
        process.env.VUE_APP_HOST_SERVER + "/api/interest/pawn_ids"
      ).then((resp) => {
        console.log("Successfully retrieved all pawn ids");
        resp.data.data.forEach((el) => {
          var intpack = this.packages.filter((id) => {
            return el == id.PackageId;
          });

          this.packages.map((pel) => {
            if (!resp.data.data.includes(pel.PackageId)) {
              this.unselected_pawnids.push(pel);
            }
          });

          this.pawn_ids.push({ id: el, name: intpack[0].PackageName });
        });
        this.dynamicRowsDetail = this.processFetchedData(this.pawn_ids);
      });
      Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/interest/mgp_ids").then(
        (resp) => {
          console.log("Successfully retrieved all mgp ids");

          this.packages.map((pel) => {
            if (!resp.data.data.includes(pel.PackageId)) {
              this.unselected_mgpids.push(pel);
            }
          });
          resp.data.data.forEach((el) => {
            var intpack = this.packages.filter((id) => {
              return el == id.PackageId;
            });

            this.mgp_ids.push({ id: el, name: intpack[0].PackageName });
          });
          this.dynamicRowsDetail1 = this.processFetchedData(this.mgp_ids);
        }
      );
    });
  },
  methods: {
    addMGP() {
      this.mgpDialog = true;
    },
    addPawn() {
      this.pawnDialog = true;
    },
    submitPawn() {
      console.log(this.selectedItem);

      Axios.post(process.env.VUE_APP_HOST_SERVER + "/api/interest/add", {
        id: parseInt(this.selectedItem),
        type: "pawn",
      }).then((resp) => {
        console.log(resp.data);
        this.pawnDialog = false;
        this.selectedItem = "";
        this.$router.go();
      });
    },
    submitMGP() {
      Axios.post(process.env.VUE_APP_HOST_SERVER + "/api/interest/add", {
        id: parseInt(this.selectedItem),
        type: "mgp",
      }).then((resp) => {
        console.log(resp.data);
        this.pmgpDialog = false;
        this.selectedItem = "";
        this.$router.go();
      });
    },
    getDisplayDate(date) {
      return moment(date).format("DD MMM YYYY");
    },
    processFetchedData(rawMsgData) {
      return rawMsgData.map(({ id, name }) => {
        return {
          rowId: id,
          id: id,
          name: name,
          action: { delete: "show" },
        };
      });
    },
    navCreateMessages() {
      this.$store.dispatch("loadView", "AddMessages");
    },
    viewMsg(id) {
      this.currentMessageView = this.rawMsgDetails.find(
        (item) => item._id == id
      );
    },
    closeMsgDialog() {
      this.currentMessageView = null;
      this.currentMessageAnalytics = null;
      this.countUsers = 0;
    },
    editMsg(id) {
      this.$router
        .push({ name: "EditMessages", params: { itemId: id } })
        .catch(() => {});
    },
    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete
      this.dialog = false;
      console.log(this.itemDeleteId);

      Axios.post(process.env.VUE_APP_HOST_SERVER + "/api/interest/remove", {
        id: parseInt(this.itemDeleteId),
      }).then((resp) => {
        console.log(resp.data);
        this.dialog = false;
        this.loading = false;
        this.itemDeleteId = null;
        this.$router.go();
      });
    },
    openDeleteDialog(id) {
      console.log(id);
      this.dialog = true;
      this.itemDeleteId = id;
    },
    openNewPage(redirectUrl) {
      window.open("http://" + redirectUrl);
    },
    viewAnalytics(id) {
      var count = 0;
      this.currentMessageAnalytics = this.rawMsgDetails.find(
        (item) => item._id == id
      );

      for (
        var i = 0;
        i < Object.keys(this.currentMessageAnalytics.msgContent).length;
        i++
      ) {
        if (this.currentMessageAnalytics.msgContent[i].includes("read")) {
          this.countUsers = ++count;
        }
      }
      // this.currentMessageAnalytics.msgContent.map((i) => {
      //   i.forEach((item) => {
      //     if (item.includes("read")) {
      //       console.log(count++);
      //     }
      //   });
      // });
    },
  },
};
</script>

<style>
.main-panel {
  width: 100%;
}

/* View Announcement Dialog */
.dialog-msg-wrapper .content {
  width: 400px;
  height: 800px;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.dialog-msg-wrapper .close-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
}

.dialog-msg-wrapper .close-section .close-btn {
  cursor: pointer;
  color: #ea6254;
  font-size: 11px;
  font-weight: bold;
}

.dialog-msg-wrapper .image-section {
  flex-basis: 170px;
}

.dialog-msg-wrapper .title-section {
  padding-top: 15px;
  text-align: start;
  font-size: 15px;
  font-weight: bold;
}

.dialog-msg-wrapper .start-date-section {
  text-align: start;
  font-size: 9px;
  padding-top: 0px;
  color: #9b9b9b;
  font-weight: bold;
}

.dialog-msg-wrapper .desc-section {
  text-align: start;
  padding-top: 10px;
  font-size: 9px;
  color: #9b9b9b;
  flex-grow: 1;
}

.dialog-msg-wrapper .action-section {
  flex-basis: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dialog-msg-wrapper .action-btn {
  width: fit-content;
  font-size: 12px;
  padding: 5px 15px 5px 15px;
  background-color: #204281;
  color: white;
  border-radius: 20px;
  cursor: pointer;
}
</style>
